(function () {
  'use strict';

  function readCfg(scriptEl) {
    if (!scriptEl || !scriptEl.textContent) return null;
    try {
      return JSON.parse(scriptEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function clampSnapDollars(d, min, max, step) {
    const n = Number(d);
    if (!Number.isFinite(n)) return min;
    let x = Math.round(n / step) * step;
    if (x < min) x = min;
    if (x > max) x = max;
    return Math.round(x * 100) / 100;
  }

  function dollarsToCents(d) {
    return Math.round(d * 100);
  }

  function pickVariant(cents, variants) {
    const exact = variants.find(function (v) {
      return v.c === cents;
    });
    if (exact) return { v: exact, snapped: false };

    const avail = variants.filter(function (v) {
      return v.a;
    });
    const pool = avail.length ? avail : variants;
    if (!pool.length) return { v: null, snapped: true };

    let best = pool[0];
    let dist = Math.abs(best.c - cents);
    for (let i = 1; i < pool.length; i++) {
      const v = pool[i];
      const d = Math.abs(v.c - cents);
      if (d < dist) {
        dist = d;
        best = v;
      }
    }
    return { v: best, snapped: best.c !== cents };
  }

  function escapeSectionSelector(section) {
    if (typeof CSS !== 'undefined' && CSS.escape) return CSS.escape(section);
    return String(section).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function mergeProductFragment(productInfo, doc) {
    const section = productInfo.dataset.section;
    const esc = escapeSectionSelector(section);
    var src = doc.querySelector('product-info[data-section="' + esc + '"]');
    if (!src) src = doc.querySelector('product-info');

    if (!src) return false;

    function mergeById(baseId) {
      var sel = '#' + baseId + '-' + section;
      var next = src.querySelector(sel);
      var cur = productInfo.querySelector(sel);
      if (!next || !cur) return;
      cur.innerHTML = next.innerHTML;
      cur.classList.toggle('hidden', next.classList.contains('hidden'));
    }

    ['Price', 'Sku', 'Inventory', 'Volume', 'Price-Per-Item', 'Volume-Note', 'Quantity-Rules', 'CartBar', 'Preorder', 'Badges'].forEach(
      mergeById
    );

    var vs = productInfo.querySelector('variant-selects');
    var vsSrc = src.querySelector('variant-selects');
    if (vs && vsSrc) vs.innerHTML = vsSrc.innerHTML;

    var sbSrc = src.querySelector('#ProductSubmitButton-' + section);
    var sbCur = productInfo.querySelector('#ProductSubmitButton-' + section);
    if (sbSrc && sbCur) {
      sbCur.toggleAttribute('disabled', sbSrc.hasAttribute('disabled'));
      var txtSrc = sbSrc.querySelector('[data-add-to-cart-text]');
      var txtCur = sbCur.querySelector('[data-add-to-cart-text]');
      if (txtSrc && txtCur) txtCur.innerHTML = txtSrc.innerHTML;
    }

    return true;
  }

  function refreshProductUI(productInfo, variantId) {
    var shopUrl = (window.theme && window.theme.routes && window.theme.routes.shop_url) || '';
    var urlPath = productInfo.dataset.url || '';
    var section = productInfo.dataset.section;
    var fetchUrl = shopUrl + urlPath + '?variant=' + variantId + '&section_id=' + encodeURIComponent(section);

    return fetch(fetchUrl)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        mergeProductFragment(productInfo, doc);
        if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
          window.Shopify.PaymentButton.init();
        }
      })
      .catch(function (e) {
        console.warn('[gift-card-amount-picker]', e);
      })
      .finally(function () {
        productInfo.querySelectorAll('input[name="id"]').forEach(function (inp) {
          inp.value = String(variantId);
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        });

        var rf = productInfo.querySelector('recipient-form');
        if (rf) rf.setAttribute('data-product-variant-id', String(variantId));

        if (productInfo.dataset.enableHistoryState === 'true' && urlPath) {
          window.history.replaceState({}, '', urlPath + '?variant=' + variantId);
        }

        if (typeof productInfo.checkLiveCartInfo === 'function') {
          productInfo.checkLiveCartInfo();
        }
      });
  }

  function initPicker(root) {
    if (root.dataset.gcInit === '1') return;
    root.dataset.gcInit = '1';

    var cfg = readCfg(root.querySelector('[data-gift-card-variant-data]'));
    if (!cfg || !Array.isArray(cfg.variants) || !cfg.variants.length) return;

    var productInfo = root.closest('product-info');
    if (!productInfo) return;

    var num = root.querySelector('[data-gift-card-amount-input]');
    var range = root.querySelector('[data-gift-card-amount-range]');
    var note = root.querySelector('[data-gift-card-amount-note]');
    var debounceTimer;

    function sync() {
      var dollars = clampSnapDollars(num ? num.value : cfg.min, cfg.min, cfg.max, cfg.step);
      if (num) num.value = String(dollars);
      if (range) range.value = String(dollars);

      var cents = dollarsToCents(dollars);
      var picked = pickVariant(cents, cfg.variants);
      if (!picked.v) return;

      if (note) {
        if (picked.snapped && picked.v.c !== cents) {
          var show = (picked.v.c / 100).toFixed(0);
          note.textContent = 'Closest available amount: ' + show;
          note.classList.remove('hidden');
        } else {
          note.textContent = '';
          note.classList.add('hidden');
        }
      }

      refreshProductUI(productInfo, picked.v.id);
    }

    function scheduleSync(delay) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(sync, delay);
    }

    if (num) {
      num.addEventListener('change', function () {
        sync();
      });
      num.addEventListener('input', function () {
        scheduleSync(220);
      });
    }

    if (range) {
      range.addEventListener('input', function () {
        if (num) num.value = range.value;
        scheduleSync(120);
      });
    }

    var syncOnLoad = root.getAttribute('data-gift-card-sync-on-load') !== 'false';
    if (syncOnLoad) {
      sync();
    }

    var details = root.querySelector('[data-gift-card-amount-details]');
    if (details && !syncOnLoad) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        if (root.dataset.gcOpenedSynced === '1') return;
        root.dataset.gcOpenedSynced = '1';
        sync();
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-gift-card-amount-picker]').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
